import { axios } from "@/lib/axios";
import { MutationConfig } from "@/lib/react-query";
import { useSnackbar } from "notistack";
import { useMutation } from "react-query";

type UpdateUserAuthorizationDTO = {
  data: {
    agree: boolean;
    ipAddress?: string;
  };
  guid: string | number | undefined;
};

const validateLead = async ({
  guid,
  data,
}: UpdateUserAuthorizationDTO): Promise<void> => {
  if (!guid) {
    return Promise.reject();
  }
  return await axios.patch(`/leads/validateLead/${guid}`, data);
};

type UseValidateLeadOptions = {
  guid: string | number | undefined;
  config?: MutationConfig<typeof validateLead>;
};

export const useValidateLead = ({ config }: UseValidateLeadOptions) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    onError: (error) => {
      const message = error.response?.data?.message || error.message;
      enqueueSnackbar(message, { variant: "error" });
    },
    ...config,
    mutationFn: validateLead,
  });
};
